import { useCallback, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Lightbox } from './Lightbox'
import { getImageUrl } from '@/lib/image-url'

type GalleryCategory = 'all' | 'rooms' | 'restaurant' | 'amenities' | 'comayagua'

interface GalleryImage {
  src: string
  alt: string
  category: GalleryCategory
}

const galleryImages: GalleryImage[] = [
  { src: '/images/nuva/rooms/room-sencilla-queen-hero.jpeg', alt: 'Sencilla Queen', category: 'rooms' },
  { src: '/images/nuva/rooms/room-deluxe-queen-hero.jpeg', alt: 'Deluxe Queen', category: 'rooms' },
  { src: '/images/nuva/rooms/room-deluxe-queen-balcony-hero.jpeg', alt: 'Deluxe Queen Balcony', category: 'rooms' },
  { src: '/images/nuva/rooms/room-junior-suite-king-hero.jpeg', alt: 'Junior Suite King', category: 'rooms' },
  { src: '/images/nuva/rooms/room-doble-queen-hero.jpeg', alt: 'Doble Queen', category: 'rooms' },
  { src: '/images/nuva/rooms/room-master-suite-hero.jpeg', alt: 'Master Suite', category: 'rooms' },
  { src: '/images/nuva/rooms/room-sencilla-queen-gallery-2.jpeg', alt: 'Detalle Sencilla Queen', category: 'rooms' },
  { src: '/images/nuva/rooms/room-deluxe-queen-gallery-2.jpeg', alt: 'Detalle Deluxe Queen', category: 'rooms' },
  { src: '/images/nuva/rooms/room-deluxe-queen-balcony-gallery-2.jpeg', alt: 'Balcón Privado', category: 'rooms' },
  { src: '/images/nuva/rooms/room-junior-suite-king-gallery-2.jpeg', alt: 'Detalle Junior Suite', category: 'rooms' },
  { src: '/images/nuva/rooms/room-doble-queen-gallery-2.jpeg', alt: 'Detalle Doble Queen', category: 'rooms' },
  { src: '/images/nuva/rooms/room-master-suite-gallery-2.jpeg', alt: 'Detalle Master Suite', category: 'rooms' },
  { src: '/images/nuva/amenities/amenity-desk-workspace.jpeg', alt: 'Área de Trabajo', category: 'rooms' },
  { src: '/images/nuva/amenities/amenity-private-work-pod.jpeg', alt: 'Cabina de Trabajo', category: 'rooms' },
  { src: '/images/restaurant/la-picota-night.webp', alt: 'Restaurante', category: 'restaurant' },
  { src: '/images/restaurant/breakfast-tipico-plate.webp', alt: 'Desayuno', category: 'restaurant' },
  { src: '/images/restaurant/breakfast-fruit.webp', alt: 'Frutas', category: 'restaurant' },
  { src: '/images/restaurant/breakfast-waffles.webp', alt: 'Waffles', category: 'restaurant' },
  { src: '/images/restaurant/carne-asada-plate.webp', alt: 'Carne Asada', category: 'restaurant' },
  { src: '/images/restaurant/grilled-chicken-poolside.webp', alt: 'Pollo', category: 'restaurant' },
  { src: '/images/restaurant/tacos-poolside.webp', alt: 'Tacos', category: 'restaurant' },
  { src: '/images/restaurant/infused-water-poolside.webp', alt: 'Aguas', category: 'restaurant' },
  { src: '/images/restaurant/breakfast-buffet-service.webp', alt: 'Buffet', category: 'restaurant' },
  { src: '/images/restaurant/breakfast-tipico-full.webp', alt: 'Típico', category: 'restaurant' },
  { src: '/images/amenities/pool-night-colonial.webp', alt: 'Piscina Nocturna', category: 'amenities' },
  { src: '/images/amenities/pool-daytime-wide.webp', alt: 'Piscina Día', category: 'amenities' },
  { src: '/images/amenities/pool-aerial-gardens.webp', alt: 'Vista Aérea', category: 'amenities' },
  { src: '/images/amenities/pool-loungers-night.webp', alt: 'Camastros', category: 'amenities' },
  { src: '/images/amenities/gardens-night-blue.webp', alt: 'Jardines Noche', category: 'amenities' },
  { src: '/images/amenities/gardens-daytime-yellow.webp', alt: 'Jardines Día', category: 'amenities' },
  { src: '/images/amenities/gardens-pool-reflection.webp', alt: 'Reflejo', category: 'amenities' },
  { src: '/images/amenities/gardens-colonial-facade.webp', alt: 'Fachada', category: 'amenities' },
  { src: '/images/lobby/reception-mural.webp', alt: 'Recepción', category: 'amenities' },
  { src: '/images/lobby/mural-parrots.webp', alt: 'Guacamayas', category: 'amenities' },
  { src: '/images/lobby/checkin-staff.webp', alt: 'Personal', category: 'amenities' },
  { src: '/images/lobby/guests-checkin.webp', alt: 'Check-in', category: 'amenities' },
  { src: '/images/comayagua/cathedral-pigeons.webp', alt: 'Catedral', category: 'comayagua' },
  { src: '/images/comayagua/cathedral-facade-tourists.webp', alt: 'Fachada Catedral', category: 'comayagua' },
  { src: '/images/comayagua/cathedral-golden-altar-full.webp', alt: 'Altar', category: 'comayagua' },
  { src: '/images/comayagua/cathedral-pipe-organ.webp', alt: 'Órgano', category: 'comayagua' },
  { src: '/images/comayagua/history-bust-statue.webp', alt: 'Busto', category: 'comayagua' },
  { src: '/images/comayagua/history-colonial-carriage.webp', alt: 'Carruaje', category: 'comayagua' },
  { src: '/images/comayagua/history-yellow-arch.webp', alt: 'Arco', category: 'comayagua' },
  { src: '/images/comayagua/plaza-tourists-tower.webp', alt: 'Plaza', category: 'comayagua' },
  { src: '/images/comayagua/colonial-colorful-street.webp', alt: 'Calle Colonial', category: 'comayagua' },
  { src: '/images/comayagua/girls-walking-street.webp', alt: 'Centro Histórico', category: 'comayagua' },
  { src: '/images/comayagua/street-mural.webp', alt: 'Mural', category: 'comayagua' },
  { src: '/images/comayagua/museum-masks.webp', alt: 'Máscaras Museo', category: 'comayagua' },
  { src: '/images/comayagua/museum-angels.webp', alt: 'Ángeles', category: 'comayagua' },
  { src: '/images/comayagua/traditions-masks.webp', alt: 'Tradiciones', category: 'comayagua' },
  { src: '/images/comayagua/traditions-procession-virgin.webp', alt: 'Procesión', category: 'comayagua' },
  { src: '/images/comayagua/traditions-sawdust-carpet-colorful.webp', alt: 'Alfombra', category: 'comayagua' },
]

const categories: { key: GalleryCategory; translationKey: string }[] = [
  { key: 'all', translationKey: 'all' },
  { key: 'rooms', translationKey: 'rooms_tab' },
  { key: 'restaurant', translationKey: 'restaurant_tab' },
  { key: 'amenities', translationKey: 'amenities_tab' },
  { key: 'comayagua', translationKey: 'comayagua_tab' },
]

export function PhotoGrid() {
  const { t } = useTranslation()
  const [activeCategory, setActiveCategory] = useState<GalleryCategory>('all')
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  const filteredImages =
    activeCategory === 'all'
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory)

  const openLightbox = useCallback((index: number) => {
    setCurrentIndex(index)
    setLightboxOpen(true)
  }, [])

  const closeLightbox = useCallback(() => setLightboxOpen(false), [])

  const goToPrev = useCallback(
    () => setCurrentIndex((prev) => (prev === 0 ? filteredImages.length - 1 : prev - 1)),
    [filteredImages.length],
  )
  const goToNext = useCallback(
    () => setCurrentIndex((prev) => (prev === filteredImages.length - 1 ? 0 : prev + 1)),
    [filteredImages.length],
  )

  return (
    <>
      <div className="mb-10 flex flex-wrap justify-center gap-2">
        {categories.map((cat) => (
          <button
            key={cat.key}
            onClick={() => setActiveCategory(cat.key)}
            className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${
              activeCategory === cat.key
                ? 'bg-terracotta text-white'
                : 'bg-cream text-wood hover:bg-cream-dark'
            }`}
          >
            {t(`gallery.${cat.translationKey}`)}
          </button>
        ))}
      </div>

      <div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
        <AnimatePresence mode="popLayout">
          {filteredImages.map((image, index) => (
            <motion.div
              key={image.src}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
              className="mb-4 break-inside-avoid"
            >
              <button
                onClick={() => openLightbox(index)}
                className="group relative block w-full overflow-hidden rounded-lg"
              >
                <img
                  src={getImageUrl(image.src)}
                  alt={image.alt}
                  className="w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-wood-dark/0 transition-colors duration-300 group-hover:bg-wood-dark/30" />
              </button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      <Lightbox
        images={filteredImages}
        currentIndex={currentIndex}
        isOpen={lightboxOpen}
        onClose={closeLightbox}
        onPrev={goToPrev}
        onNext={goToNext}
      />
    </>
  )
}
